<div [formGroup]="form" fxLayout="column" fxLayoutGap="1rem">

  <div class="flex-wrap">
    <mat-form-field redispatchProvideReadonly>
      <redispatch-erzeugungsanlage-form-prefix matPrefix [feld]="Feld.FIELD_MARKTLOKATION_CODE"
      [disabled]="!readonly && disabled"></redispatch-erzeugungsanlage-form-prefix>
      <mat-label>Marktlokation</mat-label>
      <input formControlName="code"
        [redispatchDisableControl]="disabled || readonly"
        data-qa="code"
        matInput
        name="marktlokation_code"/>
      @if (f.code.hasError('required')) {
        <mat-error>
          Bitte geben Sie eine Marktlokation ein
        </mat-error>
      }
      @if (f.code.hasError('pattern')) {
        <mat-error>
          Länge 11, nur Zahlen, startet mit einer Zahl(1-9).
        </mat-error>
      }
      @if (f.code.hasError('checkDigit')) {
        <mat-error>
          Die Prüfsumme für die Marktlokation ist nicht korrekt.
        </mat-error>
      }
    </mat-form-field>

    <mat-form-field redispatchProvideReadonly>
      <redispatch-erzeugungsanlage-form-prefix matPrefix [feld]="Feld.FIELD_MARKTLOKATION_BILANZKREIS"
      [disabled]="!readonly && disabled"></redispatch-erzeugungsanlage-form-prefix>
      <mat-label>Identifikator des Bilanzkreis</mat-label>
      <input formControlName="bilanzkreis"
        [redispatchDisableControl]="disabled || readonly"
        data-qa="bilanzkreis"
        matInput
        name="marktlokation_bilanzkreis"/>
      @if (f.bilanzkreis.hasError('required')) {
        <mat-error>
          Bitte geben Sie einen Identifikator des Bilanzkreis ein
        </mat-error>
      }
      @if (f.bilanzkreis.getError('minlength'); as error) {
        <mat-error>
          EIC zu kurz ({{ error.requiredLength }})
        </mat-error>
      }
      @if (f.bilanzkreis.getError('maxlength'); as error) {
        <mat-error>
          EIC zu lang ({{ error.requiredLength }})
        </mat-error>
      }
      @if (f.bilanzkreis.getError('invalidCharacters'); as error) {
        <mat-error>
          EIC enthält ({{ error.amount }}) ungültige/s Zeichen: {{ error.characters }}
        </mat-error>
      }
      @if (f.bilanzkreis.hasError('checkCharInvalid')) {
        <mat-error>
          ID ungültig nach erfolgter Prüfzifferberechnung (Energy Identification Code)
        </mat-error>
      }
    </mat-form-field>
  </div>

  <div class="flex-wrap">
    <mat-form-field redispatchProvideReadonly>
      <redispatch-erzeugungsanlage-form-prefix matPrefix [feld]="Feld.FIELD_MARKTLOKATION_SPANNUNGSEBENE"
      [disabled]="!readonly && disabled"></redispatch-erzeugungsanlage-form-prefix>
      <mat-label>Spannung am Netzanschlußpunkt</mat-label>
      <mat-select formControlName="spannungsebene"
        [redispatchDisableControl]="disabled || readonly"
        data-qa="spannungsebene"
        name="marktlokation_spannungsebene">
        @for (item of SpannungsebeneItems; track item.key) {
          <mat-option
            [value]="item.key">{{ item.description }}
          </mat-option>
        }
      </mat-select>
      @if (f.spannungsebene.hasError('required')) {
        <mat-error>
          Bitte wählen Sie eine Spannung am Netzanschlußpunkt aus.
        </mat-error>
      }
    </mat-form-field>

    <mat-form-field redispatchProvideReadonly>
      <redispatch-erzeugungsanlage-form-prefix matPrefix [feld]="Feld.FIELD_NETZEBENE_DES_NETZANSCHLUSSPUNKTES"
      [disabled]="!readonly && disabled"></redispatch-erzeugungsanlage-form-prefix>
      <mat-label>Netzebene des Netzanschlußpunktes</mat-label>
      <mat-select formControlName="netzebeneDesNetzanschlusspunktes"
        [redispatchDisableControl]="disabled || readonly"
        data-qa="netzebeneDesNetzanschlusspunktes"
        name="marktlokation_netzebeneDesNetzanschlusspunktes">
        <mat-option [value]="null">-</mat-option>
        @for (item of UmspannungItems; track item.key) {
          <mat-option
            [value]="item.key">{{ item.description }}
          </mat-option>
        }
      </mat-select>
    </mat-form-field>
  </div>

  <div class="flex-wrap">
    <mat-form-field redispatchProvideReadonly>
      <redispatch-erzeugungsanlage-form-prefix matPrefix [feld]="Feld.FIELD_MARKTLOKATION_MESSLOKATION_ID"
      [disabled]="!readonly && disabled"></redispatch-erzeugungsanlage-form-prefix>
      <mat-label>Messlokation-ID</mat-label>
      <input formControlName="messlokationCode"
        [redispatchDisableControl]="disabled || readonly"
        data-qa="messlokationCode"
        matInput
        name="marktlokation_messlokationCode"/>
      @if (f.messlokationCode.getError('required')) {
        <mat-error>
          Bitte geben Sie eine Messlokation-ID ein
        </mat-error>
      }
      @if (f.messlokationCode.getError('pattern')) {
        <mat-error>
          Eine Messlokation-ID besteht aus einem Ländercode und 31 Zeichen
        </mat-error>
      }
    </mat-form-field>

    <mat-form-field redispatchProvideReadonly>
      <redispatch-erzeugungsanlage-form-prefix matPrefix [feld]="Feld.FIELD_MARKTLOKATION_LIEFERANT"
      [disabled]="!readonly && disabled"></redispatch-erzeugungsanlage-form-prefix>
      <mat-label>Lieferant-Marktlokation</mat-label>
      <input formControlName="lieferant"
        [redispatchDisableControl]="disabled || readonly"
        data-qa="lieferant"
        matInput
        name="marktlokation_lieferant"/>
      @if (f.lieferant.getError('pattern')) {
        <mat-error>
          Eine Lieferant-Marktlokation besteht aus 13 Zeichen und startet mit einer Zahl zwischen 40 und 60 oder
          der 99.
        </mat-error>
      }
    </mat-form-field>
  </div>
</div>
